// Tunable knobs for the Topics widget. Keep widget-specific thresholds here so
// they're easy to find + tweak without digging through the assembly logic.
export const CONFIG = {
  // ±% change vs the previous period before a topic reads rising/declining
  // (else stable). 20 = v1 parity (trendCalculator.TREND_THRESHOLD_PCT).
  trendThresholdPct: 20,
  // How many co-occurring signals to show as chips under each topic.
  topCooccurringSignals: 2,
  // How many topic rows to render.
  maxTopics: 10,
};
